import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import {  MODEL, BASE_URL, INDEX_TITLE } from "./components/consts";
import CustomDatatable from "../../../components/Common/CustomDatatable/CustomDatatable";
import FormLayout from "../../../components/Common/FormLayout";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../store/pagetitle/actions";
import IndexActionButtons from "../../../components/Actions/Index/IndexActionButtons";
import { MODULE } from "../consts";
import CustomLink from "../../../components/Common/CustomLink";

const Index = (props) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(INDEX_TITLE));
  },[]);

  const columns = [
      {
        label: "Nombre",
        width: 20,
      },
      {
        label: "Almacén",
        width: 15,
      },
      {
        label: "Ubicación",
        width: 10,
      },
      {
        label: "Producto",
        width: 10,
      },
      {
        label: "Unidad de medida",
        width: 10,
      },
      {
        label: "Cantidad mínima",
        width: 10,
      },
      {
        label: "Cantidad máxima",
        width: 10,
      },

    ];

  const rows = (data) => {

    const rows = [];
    
    const r= data?.map((p, index) => {
      const fields = [];
    
      fields.push(
        <CustomLink
        content={p.name}
        to={`${BASE_URL}/${p.id}`}>{p.name}</CustomLink>
      );
      
      fields.push(
        <span>
          <CustomLink 
          content={p.stockWareHouse?.name}
          to={`/${MODULE}/stockwarehouse/${p.stockWareHouse?.id}`}>{p.stockWareHouse?.name}</CustomLink>
            
        </span>
      );

      fields.push(
        <span>
          <CustomLink 
          content={p.stockLocation?.name}
          to={`/${MODULE}/stocklocation/${p.stockLocation?.id}`}>{p.stockLocation?.name}</CustomLink>
            
        </span>
      );

      fields.push(
        <span>
          <CustomLink 
          content={p.product?.name}
          to={`/${MODULE}/product/${p.product?.id}`}>{p.product?.name}</CustomLink>
            
        </span>
      );

      fields.push(
        <span>
          <CustomLink
          content={p.product.productUnitOfMeasure.name}
          to={`/${MODULE}/product/${p.product.productUnitOfMeasure.id}`}>{p.product.productUnitOfMeasure.name}</CustomLink>
            
        </span>
      );

      fields.push(
        <span>
          {p.productMinQuantity}
        </span>
      );

      fields.push(
        <span>
          {p.productMaxQuantity}
        </span>
      );

      rows.push({fields : fields});
    });

    return rows;
  };

  const actionButtons =  (
    <IndexActionButtons
      url={BASE_URL}
    />
);

  return (
    <FormLayout
      actionButtons={actionButtons}
    >
      <CustomDatatable
        model={MODEL}
        checks
        columns={columns}
        rows={rows}
        filter={{
          customFilters: [],
        }}
      />
    </FormLayout>
  );
};

export default Index;
